import React from "react";
import { Box } from "@bca/ui-library";

const GradeUnclassifiedSVG: React.FunctionComponent = () => (
  <Box display="flex">
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#E5E8E9"/>
      <path d="M13.386 7.047h2.044v6.576c0 .766-.164 1.41-.492 1.935a3.037 3.037 0 0 1-1.347 1.182c-.57.265-1.226.397-1.969.397-.743 0-1.404-.132-1.982-.397a3.079 3.079 0 0 1-1.354-1.182c-.323-.524-.485-1.17-.485-1.935V7.047h2.05v6.576c0 .447.071.811.212 1.094.142.282.345.49.609.622.269.132.585.198.95.198.374 0 .69-.066.95-.198.265-.132.465-.34.602-.622.141-.283.212-.647.212-1.094V7.047Z" fill="#1D2948"/>
    </svg>
  </Box>
);

export default GradeUnclassifiedSVG;
